export const yesNoOptions = [{
  label: "Yes",
  value: "true"
},
{
  label: "No",
  value: "false"
}];

export const replacementRepair = [{
  label: "RSF"
},
{
  label: "Unit"
}].map(item => ({
  value: item.label,
  label: item.label
}));
